// OBT F3-C — Kampanya bazlı personel (Formen) durumu: bekleyen + süresi geçen.
// Kapsam backend'de: BM YALNIZ kendi Formenlerini, MY kendi alt zincirini görür
// (vekâlet genişletmez). Kampanya-üstü personel toplamı backend'de YOK.
import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchPendingRespondents, fetchLateRespondents } from '../reportApi';
import { normalizeObtError } from '../../obtErrors';

function isCanceled(error) {
  return (
    error?.code === 'ERR_CANCELED' ||
    error?.name === 'CanceledError' ||
    error?.name === 'AbortError'
  );
}

export function useRespondentReport(campaignId, { enabled = true } = {}) {
  const [state, setState] = useState({
    loading: Boolean(campaignId) && enabled,
    error: null,
    pending: [],
    late: [],
    pendingTotal: 0,
    lateTotal: 0,
  });
  const abortRef = useRef(null);

  const load = useCallback(async () => {
    if (!campaignId || !enabled) {
      setState({ loading: false, error: null, pending: [], late: [], pendingTotal: 0, lateTotal: 0 });
      return;
    }
    abortRef.current?.abort();
    const controller = new AbortController();
    abortRef.current = controller;
    setState((prev) => ({ ...prev, loading: true, error: null }));
    const opt = { signal: controller.signal };
    try {
      const [pending, late] = await Promise.all([
        fetchPendingRespondents(campaignId, { limit: 100, offset: 0 }, opt),
        fetchLateRespondents(campaignId, { limit: 100, offset: 0 }, opt),
      ]);
      if (controller.signal.aborted) return;
      setState({
        loading: false,
        error: null,
        pending: Array.isArray(pending?.items) ? pending.items : [],
        late: Array.isArray(late?.items) ? late.items : [],
        pendingTotal: pending?.page?.total ?? (pending?.items?.length || 0),
        lateTotal: late?.page?.total ?? (late?.items?.length || 0),
      });
    } catch (error) {
      if (isCanceled(error) || controller.signal.aborted) return;
      setState({
        loading: false, error: normalizeObtError(error),
        pending: [], late: [], pendingTotal: 0, lateTotal: 0,
      });
    }
  }, [campaignId, enabled]);

  useEffect(() => {
    load();
    return () => abortRef.current?.abort();
  }, [load]);

  return { ...state, reload: load };
}
